export default "__VITE_ASSET__DDke1DUU__"